import React from 'react';
import { Check } from 'lucide-react';
import { trustStrip } from '../data/mock';

const TrustStrip = () => {
  return (
    <section className="bg-[#0B1F3A] py-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {trustStrip.map((item, index) => (
            <div 
              key={index}
              className="flex items-center justify-center space-x-3 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex-shrink-0 w-6 h-6 bg-[#C8A96A] rounded-full flex items-center justify-center">
                <Check className="text-white" size={14} strokeWidth={3} />
              </div>
              <span className="text-white font-medium text-base">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
